import React from 'react';
import { LoadingScreen } from '../components/LoadingScreen';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { LocationStrip } from '../components/LocationStrip';
import { TrustBar } from '../components/TrustBar';
import { NeedSelector } from '../components/NeedSelector';
import { Treatments } from '../components/Treatments';
import { WhyUs } from '../components/WhyUs';
import { Process } from '../components/Process';
import { Team } from '../components/Team';
import { Reviews } from '../components/Reviews';
import { Faq } from '../components/Faq';
import { FinalCta } from '../components/FinalCta';
import { Footer } from '../components/Footer';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
import { OrigenToggle } from '../components/origen/OrigenToggle';
import { OrigenProvider } from '../contexts/OrigenContext';
import { useResetScrollOnLoad } from '../hooks/useResetScrollOnLoad';
export function Landing() {
  useResetScrollOnLoad();
  return <OrigenProvider data-id="element-473" data-mp="2b3a4ch2mkm4">
      <div className="w-full bg-base pb-16 md:pb-0" data-id="element-474" data-mp="2blfpzpmib6p">
        <LoadingScreen data-id="element-475" data-mp="3tftnn2y6p2p3" />
        <Navbar data-id="element-476" data-mp="3tfa27c9brw6b" />
        <main data-id="element-477" data-mp="3tes1a2bpwts2">
          <Hero data-id="element-478" data-mp="3tiftmy5ffa57" />
          <LocationStrip data-id="element-479" data-mp="3peq8kinynaox" />
          <TrustBar data-id="element-480" data-mp="3pdyb12asz2w0" />
          <NeedSelector data-id="element-481" data-mp="3pfj5krx4altv" />
          <Treatments data-id="element-482" data-mp="3pgu9crqkbtkz" />
          <WhyUs data-id="element-483" data-mp="3kfn34x42j2gf" />
          <Process data-id="element-484" data-mp="3kg6j48a5rgrt" />
          <Team data-id="element-485" data-mp="3kgop3wmmh9cx" />
          <Reviews data-id="element-486" data-mp="3kh7wwkik6hd8" />
          <Faq data-id="element-487" data-mp="3khpy7vk2vls0" />
          <FinalCta data-id="element-488" data-mp="l0i981d74znv" />
        </main>
        <Footer data-id="element-489" data-mp="kzgm2yiwomps" />
        <FloatingWhatsApp data-id="element-490" data-mp="l0074o3urr81" />
        <OrigenToggle data-id="element-491" data-mp="l2clysebdlgv" />
      </div>
    </OrigenProvider>;
}